import { DatePipe } from '@angular/common';
import { Component, input } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { NewRequestSummaryField } from 'src/app/models/NewRequestReadonlyField';

@Component({
    selector: 'app-new-request-summary-fields',
    standalone: true,
    imports: [TranslateModule, DatePipe],
    templateUrl: './new-request-summary-fields.component.html'
})
export class NewRequestSummaryFieldsComponent {
    fields = input.required<NewRequestSummaryField[]>();
    form = input.required<FormGroup>();

    protected showField(fieldName: string): boolean {
        return !!this.form().get(fieldName)?.value;
    }
}
